import { useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import {
  MiButton,
  MiContentDrawer,
  MiIcon,
  MiListGroupedCard,
} from "@miplatform/components";
import { IActivity } from "@miplatform/types";
import {
  groupActivitiesByDate,
  groupActivitiesForTimeline,
} from "@miplatform/utils";
import { mdiClose, mdiHistory } from "@mdi/js";
import { ActivityCard, ActivityTimeline } from "@mibuildweb/components";
import { usePriceLevels } from "@mibuildweb/hooks";
import { Box, Typography } from "@mui/material";

export function ActivityLogDrawer({ open, onClose }: ActivityLogDrawerProps) {
  const { activities, getPriceLevelActivities } = usePriceLevels();
  const { classes, theme } = useStyles();

  useEffect(() => {
    if (open) {
      getPriceLevelActivities();
    }
  }, [open]);

  return (
    <MiContentDrawer
      open={open}
      width={500}
      Header={
        <Box className={classes.headerBox}>
          <Box className={classes.headerTitleBox}>
            <MiIcon path={mdiHistory} color={theme.palette.primary.main} />
            <Typography fontWeight={theme.fontWeight.semiBold}>
              Activity Log
            </Typography>
          </Box>
          <MiButton
            startIcon={{ path: mdiClose, iconColor: theme.palette.grey.main }}
            onClick={onClose}
          />
        </Box>
      }
    >
      <Box className={classes.drawerContent}>
        {Object.entries(groupActivitiesByDate(activities)).map(
          ([date, activities]) => {
            const timelineData = {
              [date]: groupActivitiesForTimeline(activities),
            };

            return (
              <MiListGroupedCard
                key={date}
                title={date}
                renderCard={
                  <ActivityTimeline
                    disableSpacing
                    data={timelineData}
                    showHeader={false}
                    showDate={false}
                    renderDetail={(activity: IActivity) => (
                      <ActivityCard activity={activity} showCardBorder />
                    )}
                  />
                }
              />
            );
          }
        )}
      </Box>
    </MiContentDrawer>
  );
}

const useStyles = makeStyles()((theme) => ({
  headerBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.grey.lightAccent,
  },
  headerTitleBox: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  drawerContent: {
    padding: theme.spacing(2),
    overflow: "auto",
    height: "100%",
    width: "100%",
  },
}));

interface ActivityLogDrawerProps {
  open: boolean;
  onClose: () => void;
}
